import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { delay, of, tap } from 'rxjs';

@Component({
  selector: 'app-page-not-found',
  template: `<h2>Not Found</h2><p>The page you requested does not exist, you will be redirected to the home page  shortly</p>`
})
export class PageNotFoundComponent implements OnInit {
  constructor(private router:Router) { }
  ngOnInit() {
    of(true).pipe(delay(2000),tap(data=> this.router.navigateByUrl('/'))).subscribe();
   
  }

}
